// extracted by mini-css-extract-plugin
module.exports = {"middle":"FAQPage_middle__14Ccy"};